import "./About.css";
import {Container, Group, Badge, SimpleGrid} from "@mantine/core";
import Footer from "../Components/Footer";
import Navbar from "../Components/Navbar";
import React from "react";
import { Image, Title, Text } from "@mantine/core";
import { Card } from "antd";
import Softwaredev from '../Images/countries.png';
import Saas from '../Images/service.png';
import Devops from '../Images//experts.png'
import Industryexperties from "../Components/Industryexperties";

const mockdata = [
    {
        image: Devops,
        title: "Lean, Expert Teams",
        description: "Highly skilled consultants assure quality with minimal overhead",
    },
    {
        image: Softwaredev,
        title: "Onsite–Offshore Model",
        description: "Optimized for cost and global scalability",
    },
    {
        image: Saas,
        title: "Automation & Frameworks",
        description: "Accelerated delivery across all phases of the SDLC",
    },
    // {
    //     image: Saas,
    //     title: "3+ Years of Excellence",
    //     // description: "Monolith to microservices migration, application modernization, cloud workload migration.",
    // },
    // {
    //     image: Webdev,
    //     title: "And other industries",
    //     description: "Full Stack (Java/.Net), Java Spring Boot, Salesforce, React, Angular development with modern frameworks.",
    // },

];
function Aboutus() {
  // const issmallscreen = useMediaQuery('(max-width: 768px)');
  const features = mockdata.map((feature) => (
    <Card
        key={feature.title}
        shadow="md"
        radius="md"
        className="heading-card"
        padding="xl"
    >
        {/* <feature.icon size={50} stroke={2} color={theme.colors.blue[6]} /> */}
        <Image src={feature.image} alt={feature.title} h={50} w={50} />
        <Text fz="lg" fw={700} className={"heading-title"} mt="md" c={'white'}>
            {feature.title}
        </Text>
        <Text fz="sm" c="dimmed" mt="sm">
            {feature.description}
        </Text>
    </Card>
));
  return (
    <>
      <Navbar />
      {/* <div className="sky-container">
        <Image src={Skyimage} alt="header-img" h={200}/>
        <div className="centered">About us</div>
      </div> */}
      <Group justify='center' mt={'xl'}>
        <Badge variant="outline" size="lg" p={'lg'} mt={'xl'} className='heading-pills'>
          Our Story
        </Badge>
      </Group>
      <Container mt={"xs"} size={"lg"} data-aos="fade-right">
        <Title ta={'center'} className='heading-as-text' size={'60'}>
          Innovation Through Technology
        </Title>
        <Group justify='center'>
          <Text c={'white'} fw={'bold'} className='heading-description' mt={'md'}>
            At GV InfoTech.org Consulting, technology is the foundation of innovation and growth. We partner with product and service companies worldwide to architect, design, and implement scalable enterprise solutions.
          </Text>
        </Group>

        <SimpleGrid cols={{ base: 1, md: 3 }} spacing="xl" mt={50}>
          {features}
        </SimpleGrid>

        <Industryexperties/>
      </Container>




      {/* <Container mt={"xl"} size={"lg"}>
        <Grid>
          <Grid.Col span={{ xs: 12, sm: 12, md: 6, lg: 6 }}>
            <Image src={devimg} alt="About us" h={500} w={520} style={{ display: issmallscreen ? 'none' : 'flex' }} />
          </Grid.Col>
          <Grid.Col span={{ xs: 12, sm: 12, md: 6, lg: 6 }}>
            <Title size={30} c={"dimmed"}>
              Your Partner for Tech Innovation
            </Title>

            <Text mt={"md"} size={"md"}>
              GV InfoTech is the partner of choice for many of the
              world’s leading enterprises, SMEs, and technology challengers. We
              help businesses elevate their value through custom software
              development, product design, QA, and consultancy services.
            </Text>

            <Text mt={"md"} size={"md"}>
              What sets us apart is our unwavering commitment to excellence. We
              adhere to strict timelines and maintain meticulous project
              management to ensure timely delivery without compromising on
              quality. Our success is reflected in the satisfaction of our
              clients, who consistently commend us for our reliability,
              professionalism, and outstanding results.
            </Text>

            <Text mt={"md"} size={"md"}>
              Thank you for choosing GV InfoTech, where your success is our mission.
            </Text>
          </Grid.Col>
        </Grid>

        <Box mt={'lg'}>
          <Card style={{ boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 24px", padding: '20px' }}>
            <Grid>
              <Grid.Col span={{ xs: 12, sm: 4, md: 4, lg: 4 }}>
                <Title>3+</Title>
                <Text size="sm">Year Of Experience</Text>
              </Grid.Col>
              <Grid.Col span={{ xs: 12, sm: 4, md: 4, lg: 4 }}>
                <Title>12+</Title>
                <Text size="sm">National & International Project Successfully Delivered</Text>
              </Grid.Col>
              <Grid.Col span={{ xs: 12, sm: 4, md: 4, lg: 4 }}>
                <Title>10 to 12+</Title>
                <Text size="sm">Our Team Size</Text>
              </Grid.Col>
            </Grid>
          </Card>
        </Box>

      </Container> */}


      <Footer />
    </>
  );
}

export default Aboutus;
